import { BoxContainer, PrimaryButton, ReactIcons } from "@kalyzee/kalyzee-ui";

import workBoxStyles from "./WorkBox.module.css";

import styles from "./ChatWorkBox.module.css";

export interface ChatWorkBoxProps {
  children: React.ReactNode;
  onClearMessages?: () => void;
  onClose?: () => void;
}

export const ChatWorkBox = ({
  children,
  onClearMessages,
  onClose,
}: ChatWorkBoxProps) => {
  const right: React.ReactNode[] = [];
  if (onClearMessages) {
    right.push(
      <PrimaryButton onClick={onClearMessages}>
        <ReactIcons.Trash style={{ width: 25 }} />
      </PrimaryButton>
    );
  }
  if (onClose) {
    right.push(
      <PrimaryButton onClick={onClose}>
        <ReactIcons.Close style={{ height: "0.8em" }} />
      </PrimaryButton>
    );
  }

  return (
    <BoxContainer
      style={{ width: "100%", height: "100%" }}
      topBarProps={{
        left: [
          <ReactIcons.ChatBubble style={{ width: "1.5em", height: "1.5em" }} />,
        ],
        center: [
          <span className={workBoxStyles.label}>Chat</span>
        ],
        right,
      }}
    >
      {children}
    </BoxContainer>
  );
}